export default "__VITE_ASSET__Duh$KZZJ__"